import React from 'react';

export default function Price(props) {
    const price = props.price == null ? [0,0] : props.price.toString().split('.');
    return <span className={`product-price ${props.size ? props.size : ""}`}>
            {`$${price[0]}${price[1] > 0 ? '.' : ''}`}<span className="cents">{price[1] > 0 ? price[1] : null}</span>
            </span>
}
